import { useEffect } from "react";
import { Button, Checkbox, Form, Radio } from "antd";

import {
  OPTIONS_PERMISSION,
  PERMISSION_DEFAULT_VALUE,
} from "../../../../../../constant";

const TabPermissionsWealthAdvisor = ({
  disableEdit,
  clientPermissions,
  handleSave,
  handleViewFolders,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      allowSetGoals: clientPermissions?.setGoals ?? true,
      manageLeads: clientPermissions?.manageLeads ?? PERMISSION_DEFAULT_VALUE,
      manageClients:
        clientPermissions?.manageClients ?? PERMISSION_DEFAULT_VALUE,
      manageProposals:
        clientPermissions?.manageProposals ?? PERMISSION_DEFAULT_VALUE,
    });
  }, [clientPermissions]);

  return (
    <Form
      disabled={disableEdit}
      form={form}
      id="formPermissionsAdmin"
      onFinish={handleSave}
    >
      <div className="container-permission">
        <h4>Advisor</h4>
        <div className="container-values">
          <Form.Item label="Manage Leads" name="manageLeads">
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <div className="divider" />
          <Form.Item label="Manage Clients" name="manageClients">
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <Form.Item label="Manage Proposals" name="manageProposals">
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
        </div>
      </div>

      <div className="container-permission">
        <h4>Marketing Content</h4>
        <div className="container-values">
          <Button
            disabled={disableEdit}
            onClick={handleViewFolders}
            shape="round"
            size="small"
          >
            View Folders
          </Button>
        </div>
      </div>

      <div className="container-permission">
        <h4>Dashboard</h4>
        <div className="container-values">
          <div style={{ width: "fit-content" }}>
            <Form.Item
              label="Set Goals"
              name="allowSetGoals"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </div>
        </div>
      </div>

      <div style={{ padding: "12px 32px" }}>
        <Button
          disabled={loading}
          htmlType="submit"
          shape="round"
          size="small"
          type="primary"
        >
          Apply Changes
        </Button>
      </div>
    </Form>
  );
};

export default TabPermissionsWealthAdvisor;
